import { lazy } from 'react';
import { authRoles } from 'app/auth';

const OrderAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.diller, ...authRoles.dillerHelper],
	routes: [
		{
			path: '/apps/diller/ordersByDiller',
			exact: true,
			component: lazy(() => import('./single/Data'))
		},
		{
			path: '/apps/diller/ordersByDiller/:id',
			exact: true,
			component: lazy(() => import('./products'))
		}
	]
};

export default OrderAppConfig;
